import { render, staticRenderFns } from "./HLSVideoPlayer.vue?vue&type=template&id=583573b1"
import script from "./HLSVideoPlayer.vue?vue&type=script&lang=js"
export * from "./HLSVideoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports